/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DefinitionNameLabel = {
    AreaFlatnessAreaRatio: 'AreaFlatnessAreaRatio',
    AreaFlatnessCaxRatio: 'AreaFlatnessCAXRatio',
    BeamProfileConstancyAapmTg14220090817: 'BeamProfileConstancyAAPM_TG142_20090817',
    BeamQualityFactorUnicheck: 'BeamQualityFactorUnicheck',
    CaxDeviationPenumbraFitInfl: 'CAXDeviationPenumbraFitINFL',
    CaxDeviationPenumbraFitLevel: 'CAXDeviationPenumbraFitLevel',
    FlatnessAreaRatio: 'FlatnessAreaRatio',
    FlatnessCaxRatio: 'FlatnessCAXRatio',
    NonSpecificDose: 'NonSpecificDose',
    RadFieldSizeByPenumbraFitInfl: 'RadFieldSizeByPenumbraFitINFL',
    RadFieldSizeByPenumbraFitLevel: 'RadFieldSizeByPenumbraFitLevel',
    StabilityIndexAnsmPenumbraFitInfl: 'StabilityIndexAnsmPenumbraFitINFL',
    StabilityIndexAnsmPenumbraFitLevel: 'StabilityIndexAnsmPenumbraFitLevel',
    SymmetryArea: 'SymmetryArea',
    SymmetryIsodose: 'SymmetryIsodose',
    SymmetryPercOfFs: 'SymmetryPercOfFS',
    UnicheckAirPressure: 'UnicheckAirPressure',
    UnicheckAirTemperature: 'UnicheckAirTemperature',
    BeamQualityFactorQuickcheck: 'BeamQualityFactorQUICKCHECK',
    CaxDoseQuickcheck: 'CaxDoseQUICKCHECK',
    Flatness2D1Quickcheck: 'Flatness2D1QUICKCHECK',
    Flatness2D2Quickcheck: 'Flatness2D2QUICKCHECK',
    Flatness2D3Quickcheck: 'Flatness2D3QUICKCHECK',
    Flatness2D4Quickcheck: 'Flatness2D4QUICKCHECK',
    Symmetry1Quickcheck: 'Symmetry1QUICKCHECK',
    Symmetry2Quickcheck: 'Symmetry2QUICKCHECK',
    Symmetry3Quickcheck: 'Symmetry3QUICKCHECK',
    Symmetry4Quickcheck: 'Symmetry4QUICKCHECK',
    WedgeAngleQuickcheck: 'WedgeAngleQUICKCHECK',
    FlattenedAreaDdLarge: 'FlattenedAreaDdLarge',
    FlattenedAreaDdMid: 'FlattenedAreaDdMid',
    FlattenedAreaDdSmall: 'FlattenedAreaDdSmall',
    FlattenedAreaDmLarge: 'FlattenedAreaDmLarge',
    FlattenedAreaDmMid: 'FlattenedAreaDmMid',
    FlattenedAreaDmSmall: 'FlattenedAreaDmSmall',
    FlattenedAreaLowerRangeLargeRadiationFields: 'FlattenedAreaLowerRangeLargeRadiationFields',
    FlattenedAreaLowerRangeMidRadiationFields: 'FlattenedAreaLowerRangeMidRadiationFields',
    FlattenedAreaLowerRangeSmallRadiationFields: 'FlattenedAreaLowerRangeSmallRadiationFields',
    HorizontalChamberDistance: 'HorizontalChamberDistance',
    IsodoseDmin: 'IsodoseDmin',
    PercOfAbsDose: 'PercOfAbsDose',
    PercOfNominalFs: 'PercOfNominalFS',
    VerticalChamberDistance: 'VerticalChamberDistance',
    VisibleBoreHolesEpidsoft: 'VisibleBoreHolesEPIDSOFT',
    SignalToNoiseRatioEpidsoft: 'SignalToNoiseRatioEPIDSOFT',
    ScalingDiscrepancyEpidsoft: 'ScalingDiscrepancyEPIDSOFT',
    OffsetPosition: 'OffsetPosition',
    ModulationTransferFunctionEpidsoft: 'ModulationTransferFunctionEPIDSOFT',
    MinimumContrastOfVisibleBoreHolesEpidsoft: 'MinimumContrastOfVisibleBoreHolesEPIDSOFT',
    MaximumDeviationLinearityEpidsoft: 'MaximumDeviationLinearityEPIDSOFT',
    LocalDependencyOfLinearityEpidsoft: 'LocalDependencyOfLinearityEPIDSOFT',
    Distortion: 'Distortion',
    DistortionSqrt2A1D1: 'DistortionSqrt2A1D1',
    DistortionA1A2: 'DistortionA1A2',
    DistortionA2A3: 'DistortionA2A3',
    DistortionA3A4: 'DistortionA3A4',
    DistortionD1D2: 'DistortionD1D2',
    ImageFlatnessEpidsoft: 'ImageFlatnessEPIDSOFT',
    ImageNoiseEpidsoft: 'ImageNoiseEPIDSOFT',
    ImageNoiseRelativeEpidsoft: 'ImageNoiseRelativeEPIDSOFT',
    ImageRotationEpidsoft: 'ImageRotationEPIDSOFT'
} as const;
export type DefinitionNameLabel = typeof DefinitionNameLabel[keyof typeof DefinitionNameLabel];


export function DefinitionNameLabelFromJSON(json: any): DefinitionNameLabel {
    return DefinitionNameLabelFromJSONTyped(json, false);
}

export function DefinitionNameLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefinitionNameLabel {
    return json as DefinitionNameLabel;
}

export function DefinitionNameLabelToJSON(value?: DefinitionNameLabel | null): any {
    return value as any;
}

/**
 * Check if a given object implements the DefinitionNameLabel interface.
 */
 export function instanceOfDefinitionNameLabel(value: any): value is DefinitionNameLabel {
    return Object.values(DefinitionNameLabel).includes(value)
}

